export default __webpack_public_path__ + "static/media/EDO-Kompas.94b7e830.pdf";